// utils/setupCollapsibles.ts

export const setupCollapsibles = (): void => {
    const collapsibles = document.querySelectorAll<HTMLButtonElement>(".collapsible");
  
    collapsibles.forEach((button) => {
      // Replace the element to remove old event listeners 
      const newButton = button.cloneNode(true) as HTMLButtonElement;
      button.parentNode?.replaceChild(newButton, button);
  
      newButton.addEventListener("click", () => {
  
        newButton.classList.toggle("active-collapse");
  
        const content = newButton.nextElementSibling as HTMLElement | null;
  
        if (content) {
          if (content.style.maxHeight) {
            content.style.maxHeight = "";
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        }
      });
    });
};
  